var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn num-btn",attrs:{"id":"NUMBER_6","name":"6","data-vcode":"NUMBER_6","aria-label":"6 MNO"}},[_c('div',{staticClass:"digit"},[_vm._v("6")]),_c('div',{staticClass:"letters"},[_vm._v("MNO")])])
}]

export { render, staticRenderFns }